import axios, { AxiosInstance } from 'axios'
import { makeUseAxios, UseAxios } from 'axios-hooks'
import { AccessTokenKey, GMMSRaceTeamKey, RescaleTokenKey } from '../../utils/constants'
import { appEventInstance } from '../../utils/event'

export const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'x-api-key': process.env.API_KEY,
    Authorization: `Bearer ${localStorage.getItem(AccessTokenKey)}`,
    AuthorizationRescale: localStorage.getItem(RescaleTokenKey)
  },
  timeout: 120 * 1000, // 2 minutes - allow longer backend processing
  withCredentials: true
})

export const useAxiosClient: UseAxios = makeUseAxios({
  axios: apiClient,
  defaultOptions: {
    manual: true,
    useCache: false,
    ssr: false,
    autoCancel: false
  }
})

apiClient.interceptors.request.use(
  async request => {
    console.log('Request intercepted', request)
    const accessToken = localStorage.getItem(AccessTokenKey)
    const teamId = localStorage.getItem(GMMSRaceTeamKey)
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers.AuthorizationRescale =
      localStorage.getItem(RescaleTokenKey) || 'dummy-reascale-token'
    request.headers.GMMSRaceTeamId = teamId || 'dummy-race-team-id'

    return request
  },
  error => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  function (response) {
    console.log('Response intercepted')
    return response
  },
  function (error) {
    if (axios.isCancel(error) || error.code === 'ERR_CANCELED') {
      return Promise.reject(error)
    }
    console.error('response error: ', error)
    if (error.response) {
      if (error.response.status === 401) {
        appEventInstance.error401()
        return Promise.resolve(error)
      }
      if (error.response.status === 403) {
        appEventInstance.error403()
        return Promise.reject(error) // Reject so callers' .catch runs; resolving made denied writes look successful
      }
      return Promise.reject(error)
    } else if (error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK') {
      appEventInstance.errorNetwork()
      return Promise.reject(error) // Changed from Promise.resolve to Promise.reject
    } else {
      return Promise.reject(error)
    }
  }
)
